export const FEATURE_FLAGS = {
  suggestLocalCurrencyForConverter: 'specs.stores.suggestLocalCurrencyForConverter',
  suggestAutoCurrencySwitchConverter: 'specs.stores.suggestAutoCurrencySwitchConverter',
  alwaysSuggestCurrency: 'specs.stores.alwaysSuggestCurrency',
  useEcomCurrencySettingsApi: 'specs.stores.useEcomCurrencySettingsApi',
};
